import React, { CSSProperties, useState } from "react";

import { Button, Form, Input } from "semantic-ui-react";

import ReCAPTCHA from "react-google-recaptcha";

import EmailLoginManager from "react-lib/apps/IsHealth/Common/EmailLogin/EmailLoginManager";

type EmailRegisterFormProps = {
  email: string;
  onSuccess: (message: string) => void;
};

type Styles = Record<"errorMessage", CSSProperties>;

const styles: Styles = {
  errorMessage: {
    alignItems: "center",
    backgroundColor: "#fff1f0",
    border: "1px solid #ffccc7",
    borderRadius: "8px",
    color: "#cf1322",
    display: "flex",
    fontSize: "13px",
    marginTop: "8px",
    padding: "12px 16px",
  },
};

const RECAPTCHA_SITE_KEY = "6LdvmfUUAAAAAIb2DBfgd_xeN-xk4b6qq_3aR-UH";

const EmailRegisterForm: React.FC<EmailRegisterFormProps> = (props) => {
  const manager = new EmailLoginManager();

  const [email, setEmail] = useState(props.email || "");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [recaptcha, setRecaptcha] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    try {
      await manager.requestLogin(email);
    } catch {
      // ---
    }
  };

  // Create account function from Register component
  const handleCreate = async () => {
    setErrorMessage("");
    setIsLoading(true);

    try {
      await manager.register(email, recaptcha, firstName, lastName);

      void handleLogin();

      setIsLoading(false);

      props.onSuccess(email);
    } catch (error: any) {
      const message = JSON.stringify(
        error.response?.data?.email?.[0] || error.response?.data?.detail || error.response?.data
      );

      setErrorMessage(message);
      setIsLoading(false);
    }
  };

  // Handle form submission
  const handleEmailSubmit = () => {
    if (!email || !firstName || !lastName || !recaptcha) {
      setErrorMessage("กรุณากรอกข้อมูลให้ครบถ้วน");

      return;
    }

    void handleCreate();
  };

  return (
    <>
      <Form style={{ marginBottom: "1.4rem" }}>
        <Form.Field>
          <label style={{ color: "#2B2B2B", fontSize: "15px" }}>ลงชื่อเข้าใช้งานด้วย Email</label>
          <Input
            ref={(ref: any) => {
              if (ref) {
                ref.inputRef.current.style.borderRadius = "10px";
              }
            }}
            placeholder="name@mail.com"
            size="large"
            type="email"
            value={email}
            fluid
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Field>

        <Form.Field>
          <label style={{ color: "#2B2B2B", fontSize: "15px" }}>ชื่อ</label>
          <Input
            ref={(ref: any) => {
              if (ref) {
                ref.inputRef.current.style.borderRadius = "10px";
              }
            }}
            placeholder="ระบุชื่อ"
            size="large"
            type="text"
            value={firstName}
            fluid
            required
            onChange={(e) => setFirstName(e.target.value)}
          />
        </Form.Field>

        <Form.Field>
          <label style={{ color: "#2B2B2B", fontSize: "15px" }}>นามสกุล</label>
          <Input
            ref={(ref: any) => {
              if (ref) {
                ref.inputRef.current.style.borderRadius = "10px";
              }
            }}
            placeholder="ระบุนามสกุล"
            size="large"
            type="text"
            value={lastName}
            fluid
            required
            onChange={(e) => setLastName(e.target.value)}
          />
          {!!errorMessage && (
            <div style={styles.errorMessage}>
              <span style={{ marginRight: "8px" }}>⚠</span>
              <span>{errorMessage}</span>
            </div>
          )}
        </Form.Field>
      </Form>

      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        size="normal"
        onChange={(value: string) => {
          setRecaptcha(value);
        }}
      />

      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
        <Button
          style={{
            backgroundColor: "var(--primary-theme-color)",
            borderRadius: "28px",
            fontSize: "15px",
            width: "68%",
          }}
          disabled={isLoading}
          loading={isLoading}
          size="large"
          onClick={handleEmailSubmit}
        >
          ถัดไป
        </Button>
      </div>
    </>
  );
};

export default EmailRegisterForm;
